module.exports = __webpack_public_path__ + "img/tarjetas_tarot.6ae0ff7b.svg";